import React, { FC } from "react";
import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import { ReactComponent as InvalidFilterIcon } from "./icons/invalid-filter-icon.svg";
import { ReactComponent as NotEnoughPeersIcon } from "./icons/not-enough-peers-icon.svg";
import { ReactComponent as FilterIcon } from "./icons/filter-icon.svg";
import { BenchMarkErrorType, BenchmarkScreenType } from "../../../shared/enum";
import "./styles.css";

interface BenchmarkErrorPagePropTypes {
  currentPeerCount: number;
  errorType: BenchMarkErrorType;
  screenType: BenchmarkScreenType;
}

const BenchmarkErrorPage: FC<BenchmarkErrorPagePropTypes> = ({
  currentPeerCount,
  errorType,
  screenType,
}) => {
  console.log(errorType, screenType);
  const errorConfig = {
    [BenchMarkErrorType.INVALID_FILTER]: {
      [BenchmarkScreenType.CHANNEL_BENCHMARK]: {
        icon: <InvalidFilterIcon />,
        title: "Invalid filter combination.",
        description:
          "No hotels match your current filter criteria. This combination may be too specific or the filters conflict with each other. Please adjust your selection.",
        suggestions: [
          "Remove conflicting filters that are too restrictive",
          "Start with one of the predefined peer set presets",
          "Try selecting a larger market area or different property size",
          "Contact support if you believe this is an error",
        ],
      },

      [BenchmarkScreenType.MMA]: {
        icon: <NotEnoughPeersIcon />,
        title: "No Media Mix Available.",
        description:
          "We couldn't find enough comparable properties to generate a reliable Media Mix Analysis for this selection.",
        suggestions: [
          "Try selecting a different benchmark view or choosing another reporting period.",
        ],
      },

      [BenchmarkScreenType.MEI]: {
        icon: <NotEnoughPeersIcon />,
        title: "No Marketing Efficiency Index Available.",
        description:
          "We couldn't find enough comparable properties to generate a reliable Marketing Efficiency Index for this selection.",
        suggestions: [
          "Try selecting a different benchmark view or choosing another reporting period.",
        ],
      },
    },

    [BenchMarkErrorType.NOT_ENOUGH_PEER]: {
      [BenchmarkScreenType.CHANNEL_BENCHMARK]: {
        icon: <NotEnoughPeersIcon />,
        title: "No Benchmark Available.",
        description:
          "We couldn't find enough comparable properties to generate a reliable benchmark for this selection.",
        suggestions: [
          "Try selecting a different benchmark view or choosing another reporting period.",
        ],
      },

      [BenchmarkScreenType.MMA]: {
        icon: <NotEnoughPeersIcon />,
        title: "No Media Mix Available.",
        description:
          "We couldn't find enough comparable properties to generate a reliable Media Mix Analysis for this selection.",
        suggestions: [
          "Try selecting a different benchmark view or choosing another reporting period.",
        ],
      },

      [BenchmarkScreenType.MEI]: {
        icon: <NotEnoughPeersIcon />,
        title: "No Marketing Efficiency Index Available.",
        description:
          "We couldn't find enough comparable properties to generate a reliable Marketing Efficiency Index for this selection.",
        suggestions: [
          "Try selecting a different benchmark view or choosing another reporting period.",
        ],
      },
    },
  };

  const currentContent = errorConfig[errorType][screenType];
  return (
    <Paper
      className="card-panel matrix-card benchmark-error-container"
      elevation={0}
    >
      <Stack spacing={3} alignItems="center">
        <Box className="peer-count-wrapper">
          {currentContent.icon}
          <Box className="peer-count-pill">
            <Typography variant="caption" className="peer-count-text">
              Current peer count: {currentPeerCount}
            </Typography>
          </Box>
        </Box>

        <Box className="error-text-container">
          <Typography className="error-title">
            {currentContent.title}
          </Typography>
          <Typography variant="body2" className="error-description">
            {currentContent.description}
          </Typography>
        </Box>

        <Box className="suggestions-wrapper">
          <Typography variant="body2" className="suggestions-title">
            Suggestions to improve your peer set:
          </Typography>

          <Box className="suggestions-box" sx={{ mt: 2 }}>
            <ul className="suggestions-list">
              {currentContent.suggestions.map(
                (suggestion: string, index: number) => (
                  <li key={index} className="suggestions-list-item">
                    {suggestion}
                  </li>
                ),
              )}
            </ul>
          </Box>
        </Box>

        {/* <Button
          variant="contained"
          startIcon={<FilterIcon />}
          className="adjust-filters-button"
        >
          Adjust Filters
        </Button> */}
      </Stack>
    </Paper>
  );
};

export default BenchmarkErrorPage;
